import About from "./components/About";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import "./index.css";
function App() {
  return (
    <div>
      <Hero />
      <About />
      <Footer />
    </div>
  );
}

export default App;
